export default "__VITE_ASSET__25dcfc85__"